
namespace GeniuzPOS.Administration {

    @Serenity.Decorators.registerClass()
    export class PsFuncKbMapKeyCodeGrid extends Serenity.EntityGrid<PsFuncKbMapKeyCodeRow, any> {
        protected getColumnsKey() { return PsFuncKbMapKeyCodeColumns.columnsKey; }
        protected getDialogType() { return PsFuncKbMapKeyCodeDialog; }
        protected getIdProperty() { return PsFuncKbMapKeyCodeRow.idProperty; }
        protected getInsertPermission() { return PsFuncKbMapKeyCodeRow.insertPermission; }
        protected getLocalTextPrefix() { return PsFuncKbMapKeyCodeRow.localTextPrefix; }
        protected getService() { return PsFuncKbMapKeyCodeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}